module.exports = new __parcel__URL__("logo-thrustcurve.3b2b2dc6.svg").toString();